module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Sửa vùng miền",
      "breadcrumbs": [{
        title: 'Quản lý vùng miền',
        route: {
          name: 'region'
        }
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-all"
  }, [_c('el-form', {
    ref: "createRegionForm",
    attrs: {
      "model": _vm.localRegion,
      "rules": _vm.rules,
      "label-width": "200px",
      "label-position": "top"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateBeforeSubmitRegion('createRegionForm')
      }
    }
  }, [_c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tên",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tên"
    },
    model: {
      value: (_vm.localRegion.name),
      callback: function($$v) {
        _vm.$set(_vm.localRegion, "name", $$v)
      },
      expression: "localRegion.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tên viết tắt",
      "prop": "short_name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tên viết tắt"
    },
    model: {
      value: (_vm.localRegion.short_name),
      callback: function($$v) {
        _vm.$set(_vm.localRegion, "short_name", $$v)
      },
      expression: "localRegion.short_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tỉnh thành thuộc vùng miền"
    }
  }, [_c('el-select', {
    staticClass: "width-100",
    attrs: {
      "multiple": "",
      "filterable": "",
      "placeholder": "Chon tỉnh thành"
    },
    model: {
      value: (_vm.localRegion.cities),
      callback: function($$v) {
        _vm.$set(_vm.localRegion, "cities", $$v)
      },
      expression: "localRegion.cities"
    }
  }, _vm._l((_vm.cities), function(city) {
    return _c('el-option', {
      key: city.id,
      attrs: {
        "label": city.name,
        "value": city.id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('button', {
    staticClass: "ui blue basic small button",
    attrs: {
      "disabled": _vm.submitting,
      "native-type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _vm._v(" Lưu lại")])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-22ed58f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/region/EditRegion.vue
// module id = 697
// module chunks = 1